import { createFileRoute } from "@tanstack/react-router";
import { BrasilChannelLanding } from "@/components/match/brasil/BrasilChannelLanding";
import { BRASIL_FAQ_BY_CHANNEL, buildFaqJsonLd } from "@/components/growth/BrasilFaq";

export const Route = createFileRoute("/brasil/cazetv")({
  head: () => ({
    meta: [
      { title: "VerseSport Brasil + CazéTV — Segunda tela com estatísticas ao vivo" },
      { name: "description", content: "Assista à CazéTV e use o VerseSport como segunda tela: previsões, Nation Wars, ranking da torcida e estatísticas em tempo real." },
      { property: "og:title", content: "VerseSport Brasil + CazéTV — Segunda tela com estatísticas ao vivo" },
      { property: "og:description", content: "Assista à CazéTV e use o VerseSport como segunda tela: previsões, Nation Wars, ranking da torcida e estatísticas em tempo real." },
      { property: "og:url", content: "https://versesport.com/brasil/cazetv" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/brasil/cazetv" }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify(buildFaqJsonLd(BRASIL_FAQ_BY_CHANNEL.cazetv)),
    }],
  }),
  component: () => (
    <BrasilChannelLanding channelId="cazetv" channelName="CazéTV" intro="Estatísticas ao vivo, previsões e Nation Wars para acompanhar a CazéTV sem perder nenhum lance." />
  ),
});
